import { render, staticRenderFns } from "./root.vue?vue&type=template&id=ff660e0a&scoped=true&lang=pug&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff660e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff660e0a')) {
      api.createRecord('ff660e0a', component.options)
    } else {
      api.reload('ff660e0a', component.options)
    }
    module.hot.accept("./root.vue?vue&type=template&id=ff660e0a&scoped=true&lang=pug&", function () {
      api.rerender('ff660e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFBau/root.vue"
export default component.exports